export default function inertTraverse(element) {
  if(!element) return true;
  if (element === document) return true;
  const inert = element?.inert;
  if (inert) return false;
  const disabled = element?.disabled;
  if (disabled) return false;
  if (!element.parentNode) return true;
  return inertTraverse(element.parentNode);
};
